export default function SkeletonCard() {
    return (
      <div className="animate-pulse bg-white shadow rounded p-4">
        <div className="h-4 bg-gray-300 rounded w-1/3 mb-2"></div>
        <div className="h-3 bg-gray-200 rounded w-full mb-1"></div>
        <div className="h-3 bg-gray-200 rounded w-5/6 mb-2"></div>
        <div className="h-40 bg-gray-100 rounded"></div>
      </div>
    );
  }
  